import { TextInput, Textarea, Stack } from "@mantine/core";
import { useForm } from "@mantine/form";
import { SalesRep } from "../../../services/admin/salesreps.service";
import { required, scrollToFirstError } from "../../../utils/formValidation";

export interface SalesRepFormValues {
  name: string;
  address: string;
  deal: string;
}

interface SalesRepFormProps {
  initialValues?: SalesRep;
  onSubmit: (values: SalesRepFormValues) => void;
}

export default function SalesRepForm({
  initialValues,
  onSubmit,
}: SalesRepFormProps) {
  const form = useForm<SalesRepFormValues>({
    initialValues: {
      name: initialValues?.name || "",
      address: initialValues?.address || "",
      deal: initialValues?.deal || "",
    },
    validate: {
      name: required("Sales rep name is required"),
    },
  });

  const handleSubmit = form.onSubmit(
    (values) => onSubmit(values),
    () => scrollToFirstError(form)
  );

  return (
    <form noValidate onSubmit={handleSubmit}>
      <Stack gap="md">
        <TextInput
          label="Sales Rep Name"
          placeholder="Enter sales representative name"
          withAsterisk
          {...form.getInputProps("name")}
        />

        <Textarea
          label="Address"
          placeholder="Enter address"
          minRows={2}
          {...form.getInputProps("address")}
        />

        <Textarea
          label="Deal"
          placeholder="Enter deal details"
          minRows={2}
          {...form.getInputProps("deal")}
        />
      </Stack>
    </form>
  );
}

export { useForm } from "@mantine/form";
